import { createContext, useContext, useState, ReactNode } from 'react';

interface BackgroundState {
    background: string;
    opacity: string;

    setBackground: (background: string) => void;
    setOpacity: (opacity: string) => void;

    resetBackground: () => void;
}

const BackgroundContext = createContext<BackgroundState | undefined>(undefined);

export const BackgroundProvider = ({ children }: { children: ReactNode }) => {
    const [background, setBackground] = useState<string>(
        '/assets/background.webp',
    );
    const [opacity, setOpacity] = useState<string>('1');

    const resetBackground = () => {
        setBackground('/assets/background.webp');
        setOpacity('1');
    };

    return (
        <BackgroundContext.Provider
            value={{
                background,
                opacity,
                setBackground,
                setOpacity,
                resetBackground,
            }}
        >
            {children}
        </BackgroundContext.Provider>
    );
};

export const useBackground = () => {
    const context = useContext(BackgroundContext);
    if (!context) {
        console.error(
            'useBackground must be used within a BackgroundProvider.',
        );
        return {
            background: '/assets/background.webp',
            opacity: '1',
            setBackground: () => {},
            setOpacity: () => {},
            resetBackground: () => {},
        };
    }
    return context;
};

export const GlobalBackground = ({
    children,
}: {
    children: React.ReactNode;
}) => {
    const { background, opacity } = useBackground();
    const isDefault = background === '/assets/background.webp';

    const filter = isDefault
        ? 'hue-rotate(var(--hue-rot)) brightness(var(--brightness)) saturate(var(--saturation))'
        : 'blur(1px)';

    return (
        <>
            <div
                className={'image-bg-overlay'}
                style={{
                    backgroundImage: `url(${background})`,
                    opacity,
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: -1,
                    filter,
                }}
            ></div>
            {children}
        </>
    );
};
